import { render, staticRenderFns } from "./CollectedEmailsComponent.vue?vue&type=template&id=64fd46e9&scoped=true&lang=html&"
import script from "./CollectedEmailsComponent.vue?vue&type=script&lang=js&"
export * from "./CollectedEmailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CollectedEmailsComponent.vue?vue&type=style&index=0&id=64fd46e9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fd46e9",
  null
  
)

export default component.exports